export function isUserLoggedIn() {
  if (typeof window === 'undefined') {
    return false;
  }

  const container = window.__agpContainer || null;
  if (container && typeof container.getService === 'function') {
    try {
      const authService = container.getService('auth');
      if (authService && typeof authService.get === 'function') {
        const state = authService.get();
        if (state && typeof state.isLoggedIn === 'boolean') {
          return state.isLoggedIn;
        }
      }
    } catch (error) {
      // ignore container lookup failures
    }
  }

  const authState = window.__authState;
  if (authState && typeof authState.isLoggedIn === 'boolean') {
    return authState.isLoggedIn;
  }

  const legacyAuth = window.Auth;
  if (legacyAuth) {
    try {
      if (typeof legacyAuth.get === 'function') {
        const state = legacyAuth.get();
        if (state && typeof state.isLoggedIn === 'boolean') {
          return state.isLoggedIn;
        }
      } else if (typeof legacyAuth.isLoggedIn === 'boolean') {
        return legacyAuth.isLoggedIn;
      }
    } catch (error) {
      // ignore legacy auth failures
    }
  }

  return false;
}

if (typeof window !== 'undefined') {
  if (typeof window.__agpIsLoggedIn !== 'function') {
    window.__agpIsLoggedIn = function () {
      try {
        return isUserLoggedIn();
      } catch (error) {
        return false;
      }
    };
  }
}
